// Chat with a task group or a task (D82).
export default {
  open: "Chat",
  openHint: "Talk to the agent about this",
  composer: {
    label: "Message",
    placeholder: "Ask the agent… Enter sends, Shift+Enter starts a new line",
    send: "Send",
    cli: "Agent CLI",
    model: "Model",
    defaultModel: "Default model",
    stream: "Streaming",
    streamHint: "Show the agent's progress as it works",
    cursorSoon: "Cursor is coming soon: its turns are refused until Cursor support is built.",
    queued: (n: number) => `${n} ${n === 1 ? "message" : "messages"} waiting for the agent`,
  },
  turn: {
    status: { queued: "Queued", starting: "Starting", running: "Working", done: "Done", failed: "Failed", cancelled: "Cancelled" },
    cancel: "Cancel",
    cancelled: "Turn cancelled",
    sending: "Sending…",
    sent: "Sent",
    delivered: "Delivered",
    waitsForStep: "Queued until the task's running step ends; then it goes to the agent.",
    waitsForTurn: "Queued behind the turn before it.",
    waitingWorker: "Waiting for the agent's worker…",
    sendFailed: (reason: string) => `Not sent: ${reason}`,
    failed: (reason: string) => `The turn failed: ${reason}`,
  },
  you: "You",
  agent: "Agent",
  empty: "No messages yet",
  emptyGroup: "Ask the agent anything about this task group. It works in the group's environment, with the group's repositories.",
  emptyTask: "Ask the agent about this task. It picks up where the task's steps left off.",
  history: {
    self: "Your recent messages travel to the agent with each prompt, encrypted on this device.",
    managed: "The agent is given this chat's recent messages by the platform (managed key).",
  },
  linkFirst: "Chats are end-to-end encrypted to your devices. Link this browser to read and write here.",
  linkThisBrowser: "Link this browser",
  checkingKeys: "Checking this browser's keys…",
  loadFailed: "Could not load the chat",
  turnFailed: "Could not start the agent",
  terminals: {
    workspace: "Agent Workspace terminal",
    workspaceHint: "A shell in the agent's container, as the agent user",
    vm: "VM terminal",
    vmHint: "A root shell in the VM itself",
  },
};
